import { TFilter } from '@centra/centra-ui/dist'

export const sortPinnedFilters = (a: [string, TFilter], b: [string, TFilter], pinnedFilters: string | null) => {
  if (pinnedFilters?.includes(a[0]) && !pinnedFilters?.includes(b[0])) {
    return -1
  } else if (!pinnedFilters?.includes(a[0]) && pinnedFilters?.includes(b[0])) {
    return 1
  } else {
    return 0
  }
}
